var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":_vm.placement,"popper-class":"fifl-popper","visible-arrow":false,"trigger":"hover"}},[_c('span',[_vm._t("default")],2),_c('img',{style:({width : _vm.iconSize + 'px'}),attrs:{"slot":"reference","src":"/image/icon/help.svg"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }